module.exports = __webpack_public_path__ + "static/media/ninx3.e4ba9de5.jpg";